<div class="rs-card">
  <div class="head">
    <div class="title">Button Variables</div>
    <div class="right-buttons">
      <button app-mat-flat-button class="left-icon-button" color="primary" (click)="onAddNew()">
        <span class="ri-add"></span>
        <span>Add Variable</span>
      </button>
    </div>
  </div>

  <div>
    <table mat-table [dataSource]="variables" #variablesTable>
      <!-- Name Column -->
      <ng-container matColumnDef="name">
        <mat-header-cell *matHeaderCellDef> Name </mat-header-cell>
        <mat-cell *matCellDef="let item"> {{ item.name }} </mat-cell>
      </ng-container>

      <!-- Source Column -->
      <ng-container matColumnDef="source">
        <mat-header-cell *matHeaderCellDef> Source </mat-header-cell>
        <mat-cell *matCellDef="let item">
          <div class="source-name" [class.active]="pressedButtonsObject[item?.source?.type]">
            <div class="d-flex align-items-center">
              <span>{{ item?.source?.text }}</span>
              <span class="icon active-content ri-controller"></span>
            </div>

            <div class="bar">
              <ng-container
                *ngIf="pressedButtonsObject[item?.source?.type] && pressedButtonsObject[item?.source?.type].pressed"
              >
                <app-gamepad-value-bar [value]="pressedButtonsObject[item?.source?.type].value"></app-gamepad-value-bar>
              </ng-container>
            </div>
          </div>
        </mat-cell>
      </ng-container>

      <!-- Value Column -->
      <ng-container matColumnDef="value">
        <mat-header-cell *matHeaderCellDef> Value </mat-header-cell>
        <mat-cell *matCellDef="let item"> {{ item.value }} </mat-cell>
      </ng-container>

      <!-- Default Value Column -->
      <ng-container matColumnDef="defaultValue">
        <mat-header-cell *matHeaderCellDef> Default Value </mat-header-cell>
        <mat-cell *matCellDef="let item"> {{ item.defaultValue }} </mat-cell>
      </ng-container>

      <!-- Editing Column -->
      <ng-container matColumnDef="editing">
        <mat-header-cell *matHeaderCellDef></mat-header-cell>
        <mat-cell *matCellDef="let item; let idx = index">
          <div (click)="$event.stopPropagation()" class="row-buttons">
            <button app-mat-icon-button (click)="onEdit(item, idx)">
              <span class="ri-edit"></span>
            </button>
          </div>
          <div (click)="$event.stopPropagation()" class="row-buttons">
            <button app-mat-icon-button (click)="onRemove(item, idx)">
              <span class="ri-delete"></span>
            </button>
          </div>
        </mat-cell>
      </ng-container>

      <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
      <mat-row *matRowDef="let row; columns: displayedColumns" class="hover-row"></mat-row>
    </table>
  </div>
</div>
<pre *appDeveloping>{{ json | json }}</pre>
